import { ReactElement } from 'react'

import FindAllProdutosImpl from 'modules/lotes/domain/usecases/FindAllProdutos'
import LoteRepository from 'modules/lotes/infra/repositories/LoteRepository'
import FindByNomeImpl from 'shared/modules/cidades/domain/usecases/FindByNome'
import CidadeRepository from 'shared/modules/cidades/infra/respositories/CidadeRepository'

import { useFiltros } from '../../hooks/filtros'
import Filtros from '../../pages/Filtros'

export const FiltrosLotesFactory = (): ReactElement => {
  const {
    id,
    setId,
    origem,
    setOrigem,
    destino,
    setDestino,
    valor,
    setValor,
    raioOrigem,
    setRaioOrigem,
    raioDestino,
    setRaioDestino,
    origemCompleta,
    setOrigemCompleta,
    destinoCompleto,
    setDestinoCompleto,
  } = useFiltros()
  const loteRepository = new LoteRepository()
  const cidadeRepository = new CidadeRepository()
  const findByNomeImpl = new FindByNomeImpl(cidadeRepository)
  const findAllProdutosImpl = new FindAllProdutosImpl(loteRepository)

  return (
    <Filtros
      id={id}
      setId={setId}
      origem={origem}
      setOrigem={setOrigem}
      destino={destino}
      setDestino={setDestino}
      valor={valor}
      setValor={setValor}
      raioOrigem={raioOrigem}
      setRaioOrigem={setRaioOrigem}
      raioDestino={raioDestino}
      setRaioDestino={setRaioDestino}
      origemCompleta={origemCompleta}
      setOrigemCompleta={setOrigemCompleta}
      destinoCompleto={destinoCompleto}
      setDestinoCompleto={setDestinoCompleto}
      findByNome={findByNomeImpl}
      findAllProdutos={findAllProdutosImpl}
    />
  )
}
